import { useState } from 'react';
import type { FallbackProps } from 'react-error-boundary';

import { useAppDispatch } from '@/Application/Hooks/Redux';
import { URL_ROUTES } from '@/constants';
import {
  Button,
  Icon,
  Link,
  Typography
} from '@/modules/perseo-billing/ui/react/src/components/beta';

import { setPaymentError } from '../../store/slices/billing';

export const ErrorFallbackBilling = ({ resetErrorBoundary }: FallbackProps) => {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    setIsLoading(true);

    try {
      dispatch(setPaymentError(null));
      resetErrorBoundary();
    } catch (error) {
      console.error('Error while invalidating queries:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="co-flex co-flex-col co-flex-1 co-justify-center co-items-center co-gap-32px co-py-16px co-bg-pds-neutral-100 co-overflow-auto">
      <Icon width={250} height={250} icon="ErrorLoadBillingIcon" />
      <div className="co-flex co-flex-col co-gap-24px">
        <Typography
          weight="semibold"
          size="h2"
          align="center"
          className="co-self-center"
        >
          No pudimos cargar esta página
        </Typography>
        <Typography color="gray-dark" align="center">
          Tenemos problemas para mostrar la información. Por favor, inténtalo de
          nuevo o regresa a tu carro de compras.
        </Typography>
      </div>
      <div className="co-flex co-flex-col co-gap-24px">
        <Button
          pl={32}
          pr={32}
          variant="contained"
          color="primary"
          type="submit"
          loading={isLoading}
          fullWidth
          onClick={handleClick}
        >
          Volver a intentar
        </Button>
        <Link
          weight="semibold"
          color="primary"
          className="co-self-center"
          href={URL_ROUTES.CART}
        >
          Ir al carro
        </Link>
      </div>
    </div>
  );
};
